module.exports = __webpack_public_path__ + "media/newstyle/images/cover-revision-b210cff89be1f39dd0f9b6a236ea7ff7.png";